import BaseDialog from 'components/BaseDialog/BaseDialog.component'
import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { releaseOrganizationMatches } from 'scenes/Dashboard/data/organizations/actions'
import { Organization } from 'scenes/Dashboard/data/organizations/types'

import { Button } from '@mui/material'

import { usePopupWithConfirmation } from './EmailButtons.hooks'

type ReleaseToFounderButtonProps = {
  className: string
  organization: Organization
  disabled?: boolean
}

export const ReleaseToFounderButton = React.memo(
  ({ className, organization, disabled = false }: ReleaseToFounderButtonProps) => {
    const organizationName = useMemo(() => organization.name, [organization])
    const { releaseMatches } = useReleaseToFounderButtonActions(organization)
    const {
      open: confirmationPopupState,
      handleCancel: handleDialogCancel,
      handleOpen: handleDialogOpen,
      handleConfirm: handleDialogConfirm,
    } = usePopupWithConfirmation(releaseMatches)
    return (
      <>
        <Button
          size="small"
          color="secondary"
          variant="outlined"
          className={className}
          disabled={disabled}
          onClick={handleDialogOpen}
        >
          Release all ready pairings
        </Button>
        <BaseDialog
          title="Release all deals Ready to founder"
          description={
            <span>
              All deals for the company <strong>{organizationName}</strong> in state <strong>Ready</strong> will be
              moved to <strong>Sent To Founder</strong> and will be available in the {"founder's"} dashboard. A
              notification email will be sent to the founder as well.
            </span>
          }
          open={confirmationPopupState}
          onClose={handleDialogCancel}
          actions={<Button onClick={handleDialogConfirm}>Proceed</Button>}
        />
      </>
    )
  }
)

ReleaseToFounderButton.displayName = 'ReleaseToFounderButton'

function useReleaseToFounderButtonActions(organization: Organization) {
  const dispatch = useDispatch()
  const releaseMatches = useCallback(() => {
    dispatch(releaseOrganizationMatches.request({ organization }))
  }, [dispatch, organization])
  return {
    releaseMatches,
  }
}
